/* tslint:disable */
/* eslint-disable */
/**
 * Minimal API - JWT Authentication with Swagger demo
 * Implementing JWT Authentication in Minimal API
 *
 * The version of the OpenAPI document: v1
 * Contact: mbobka@mbobka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisterRequest
 */
export interface RegisterRequest {
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    firstname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    lastname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    password?: string | null;
    /**
     *
     * @type {string}
     * @memberof RegisterRequest
     */
    passwordConfirmation?: string | null;
    /**
     * Токен Yandex SmartCaptcha.
     * @type {string}
     * @memberof RegisterRequest
     */
    captchaToken?: string | null;
    /**
     * Согласие на обработку персональных данных (152-ФЗ).
     * @type {boolean}
     * @memberof RegisterRequest
     */
    pdConsent?: boolean;
    /**
     * Версия текста согласия/Политики конфиденциальности.
     * @type {string}
     * @memberof RegisterRequest
     */
    consentVersion?: string | null;
}

/**
 * Check if a given object implements the RegisterRequest interface.
 */
export function instanceOfRegisterRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RegisterRequestFromJSON(json: any): RegisterRequest {
    return RegisterRequestFromJSONTyped(json, false);
}

export function RegisterRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
        'firstname': !exists(json, 'firstname') ? undefined : json['firstname'],
        'lastname': !exists(json, 'lastname') ? undefined : json['lastname'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'passwordConfirmation': !exists(json, 'password_confirmation') ? undefined : json['password_confirmation'],
        'captchaToken': !exists(json, 'captcha_token') ? undefined : json['captcha_token'],
        'pdConsent': !exists(json, 'pd_consent') ? undefined : json['pd_consent'],
        'consentVersion': !exists(json, 'consent_version') ? undefined : json['consent_version'],
    };
}

export function RegisterRequestToJSON(value?: RegisterRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'firstname': value.firstname,
        'lastname': value.lastname,
        'password': value.password,
        'password_confirmation': value.passwordConfirmation,
        'captcha_token': value.captchaToken,
        'pd_consent': value.pdConsent,
        'consent_version': value.consentVersion,
    };
}

